import api from './api';

const BASE_URL = '/classes';

const segments = () => api.get(`${BASE_URL}/segments`);

export default {
  segments,
};
